import { ConfigViewerEnvService } from '@aipb/gulliver/config-viewer/env';
import { ConfigViewerRouting } from '@aipb/gulliver/config-viewer/routing';
import { AppIdentifier, BaseEnv } from '@aipb/gulliver/env/model';
import { EnvService } from '@aipb/gulliver/env/util';
import { FrameRepository } from '@aipb/gulliver/frame/data-access';
import { RouteItem } from '@aipb/gulliver/frame/model';
import { ApplicationInitGuard } from '@aipb/gulliver/util-app';
import { capitalize } from '@aipb/shared/util/string';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class ConfigViewerInitGuard extends ApplicationInitGuard {
  labels: Record<string, string> = {
    cs: 'Čeština',
    en: 'English',
    de: 'Deutsch'
  };
  private config: BaseEnv;
  private frameRepository = inject(FrameRepository);
  private configViewerRouting = inject(ConfigViewerRouting);

  constructor(protected configViewerEnv: ConfigViewerEnvService, private envService: EnvService) {
    super('config-viewer', configViewerEnv);
    this.config = this.envService.raw;
  }

  get hasBroadcastMessageConfig(): boolean {
    return !!this.envService.raw.broadcastMessage;
  }

  setup() {
    this.frame.setStaticRoutes([
      {
        url: this.configViewerRouting.detailDefaultRouteUrl('basic-info'),
        label: 'Základní informace',
        icon: 'info'
      },
      ...(this.hasBroadcastMessageConfig
        ? [
            {
              url: this.configViewerRouting.detailDefaultRouteUrl('broadcast-message'),
              label: 'Hláška na web',
              icon: 'campaign'
            }
          ]
        : []),
      {
        url: this.configViewerRouting.detailDefaultRouteUrl('frame'),
        label: 'Frame',
        icon: 'crop_square'
      },
      {
        url: this.configViewerRouting.detailDefaultRouteUrl('auth'),
        label: 'Keycloak',
        icon: 'key'
      },
      ...Object.keys(this.config.applications)
        .sort()
        .flatMap((app) => {
          return Object.keys(this.config.applications[app]).flatMap((configId) => {
            return <RouteItem>{
              url: this.configViewerRouting.detailDefaultRouteUrl(app, configId),
              label: app
                .split('-')
                .map((s) => capitalize(s))
                .join(' '),
              sublabel: configId,
              icon: this.getApplicationIcon(<AppIdentifier>app) || 'help'
            };
          });
        })
    ]);
  }

  private getApplicationIcon(appId: AppIdentifier) {
    const apps = this.frameRepository.applications;

    return apps.find((app) => app.id === appId).icon;
  }
}
